import React, { useState, useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { WeekDatesHeaderWrapper, WeekDatesHeaderRow, WeekDatesRow } from './styled';
import { Grid } from '@mantine/core';
import { daysIndex } from '../../../shared';

const SelectedDaysHeader = () => {

  const selectedDays = useSelector(state => state.projectEntry.projectEntries.selectedDays);
  const monthCompletedHours = useSelector(state => state.projectEntry.monthCompletedHours);
  const monthWorkingHours = useSelector(state => state.projectEntry.monthWorkingHours);
  const completedWeeks = useSelector(state => state.projectEntry.completedWeeks); 
  const firstDay = selectedDays[0];

  const startMonth = moment(firstDay).format('MMM');
  const [weeklyHours, setWeeklyHours] = useState(0);

  useEffect(() => {
    const week = completedWeeks.filter(week => week.date === moment(firstDay).format('YYYY-MM-DD'))[0];
    if (week) {
      setWeeklyHours(week.hour);
    } else 
    {
      setWeeklyHours(0);
    }
  }, [selectedDays, completedWeeks]);

  return (
    <WeekDatesHeaderWrapper>
      <Grid>
        <Grid.Col lg={8} md={7} xs={12} style={{ paddingBottom: 0 }}>
          <div>Hours Entered: week <b>{weeklyHours} of 40</b> / month of {startMonth}. <b>{monthCompletedHours} of {monthWorkingHours}</b> </div>
        </Grid.Col>
        <Grid.Col lg={4} md={5} sm={8} xs={12} style={{ paddingBottom: 0 }}>
          <WeekDatesHeaderRow justify='flex-end' sm={{ justify: 'space-around' }}>
            <Grid.Col>
              <Grid grow>
                {
                  daysIndex.map((day) => (
                    <Grid.Col span={1} style={{ textAlign: 'center', padding: 0, fontSize: '14px' }} key={day}>
                      <p>
                        {day.substring(0, 2)}
                      </p>
                    </Grid.Col>
                  ))
                }
              </Grid>
            </Grid.Col>
          </WeekDatesHeaderRow>
          <WeekDatesRow justify='flex-end'>
            <Grid.Col>
              <Grid grow style={{ paddingBottom: 0 }}>
                {
                  selectedDays.map((day) => {
                    const strDay = day.getDate().toString();
                    return (
                      <Grid.Col span={1} style={{ textAlign: 'center', padding: 0, fontSize: '14px' }} key={strDay}>
                        <p data-test={`date-${strDay}`}>
                          {strDay}
                        </p>
                      </Grid.Col>
                    )
                  })
                }
              </Grid>
            </Grid.Col>
          </WeekDatesRow>
        </Grid.Col>
      </Grid>
    </WeekDatesHeaderWrapper>
  );
};

SelectedDaysHeader.propTypes = {
  selectedDays: PropTypes.arrayOf(Date),
};

export default SelectedDaysHeader;
